import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import Icon from "@mdi/react";
import { useState, ReactNode } from "react";
import * as ss from "simple-statistics";

export const colors = {
    primary: "#75ba51",
    secondary: "#87957c",
    tertiary: "#6b9999",
    error: "#ff5449",

    green: "#75ba51",
    red: "#ff5449",
    yellow: "yellow",

    neutral: "#90918b",
    text: "#FFF",
    textDark: "#2e312b",
    background: "#2e312b",
    backgroundSecondary: "#11140e",
};

export function Loading() {
    return <div className="loading">
        <div></div>
        <div></div>
        <div></div>
    </div>;
}

export function Accordion({ title, defaultOpen = false, children }: { title: ReactNode, defaultOpen?: boolean, children: ReactNode }) {
    const [open, setOpen] = useState(defaultOpen);

    return <div className="accordion bg radius shadow padding">
        <div className="header" onClick={() => setOpen(!open)}>
            <span>{title}</span>
            <Icon path={open ? mdiChevronDown : mdiChevronUp} size={1.7} />
        </div>
        {open && <div className="content">{children}</div>}
    </div>
}

export function USD({ value }: { value: number }) {
    return <span style={{ color: value > 0 ? colors.green : value < 0 ? colors.red : colors.yellow }}>
        {getUsd(value)}
    </span>;
}

export function getUsd(value: number) {
    const abs = Math.abs(value);
    const usd = Math.floor(abs);
    const cent = Math.floor((abs - usd) * 100);

    // const valueInUSD = new Intl.NumberFormat("c", { style: "currency", currency: "USD" }).format(value);

    return `${value > 0 ? '' : value < 0 ? '-' : ""}${usd.toLocaleString()}${(usd < 700 && cent > 0) ? "," + cent.toString().padStart(2, '0') : ""} $`;
}

export function Percent({ value }: { value: number }) {
    const percent = value * 100;

    return <span style={{ color: value > 0 ? colors.green : value < 0 ? colors.red : colors.yellow }}>
        {percent.toFixed(2)} %
    </span>;
}

export function Bar({ value, percent, min, max }: { value: number, percent?: number, min: number, max: number }) {

    const width = (value - min) / (max - min) * 100;
    const width0 = min > 0 ? 0 : (0 - min) / (max - min) * 100;

    return <div style={{ textAlign: "left" }}>
        {value < 0 && <span style={{ display: "inline-block", height: 20, marginLeft: width + "px", width: (width0 - width) + "px", backgroundColor: "red", marginRight: 8 }} />}
        {value >= 0 && <span style={{ display: "inline-block", height: 20, marginLeft: width0 + "px", width: (width - width0) + "px", backgroundColor: "green", marginRight: 8 }} />}

        <USD value={value} />
        {typeof percent === "number" && percent !== 0 && <> (<Percent value={percent} />)</>}
    </div>;
}

export function BarVertical({ value, min, max }: { value: number, min: number, max: number }) {
    const height = (value - min) / (max - min) * 100;
    const height0 = min > 0 ? 0 : (0 - min) / (max - min) * 100;

    return <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <USD value={value} />
        {value < 0 && <span style={{ display: "inline-block", height: (height0 - height), marginBottom: height, width: "20px", backgroundColor: "red", marginRight: 8 }} />}
        {value >= 0 && <span style={{ display: "inline-block", height: (height - height0), marginBottom: height0, width: "20px", backgroundColor: "green", marginRight: 8 }} />}
    </div>;
}

export function getMinMax(data: number[]): [number, number] {
    if (data.length === 0)
        return [0, 0];

    return [ss.min(data), ss.max(data)];
}